import { render, staticRenderFns } from "./ai-single.vue?vue&type=template&id=6d18f00e&"
import script from "./ai-single.vue?vue&type=script&lang=js&"
export * from "./ai-single.vue?vue&type=script&lang=js&"
import style0 from "./ai-single.vue?vue&type=style&index=0&id=6d18f00e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports